//Models
PJQ.models.projectStatuses = {};
PJQ.models.projectStatuses.ProjectStatus = PJQ.models.BaseModel.extend({
    idAttribute: 'projectStatusId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects'
            },
            {
                endpoint: 'statuses',
                value: this.id < 0 ? -this.id : this.id
            }
        ])
    }
});

//Collections
PJQ.collections.projectStatuses = {};
PJQ.collections.projectStatuses.ProjectStatuses = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.projectStatuses.ProjectStatus,
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects'
            },
            {
                endpoint: 'statuses'
            }
        ])
    },
    getDefault: function () {
        return _.find(this.models, function (model) {
            return model.get('isDefault');
        });
    },
    copy: function(callback){
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects'
                },
                {
                    endpoint: 'statuses'
                },
                {
                    endpoint: 'copy'
                }
            ])
        }).post().done(_.bind(function (projectStatuses) {
            this.reset(projectStatuses);
            callback();
        }, this));
    }
});
